import React from "react";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

export type DroppsDialogProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactElement;
  title?: React.ReactElement | string;
};

const DroppsDialog = ({
  onClose,
  open,
  title,
  children,
}: DroppsDialogProps) => {
  return (
    <Dialog onClose={onClose} open={open}>
      <div className="flex items-center justify-between pl-4">
        {title && <DialogTitle sx={{ padding: 0 }}>{title}</DialogTitle>}
        <IconButton
          size="large"
          onClick={onClose}
          tabIndex={0}
          style={{ outline: "revert" }}
          aria-label="close drawer"
          color="inherit"
        >
          <ClearIcon className="transition hover:opacity-50" />
        </IconButton>
      </div>
      <hr className="divider-x mb-4 mt-0" />
      <div className="px-4 pb-4">{children}</div>
    </Dialog>
  );
};

export { DroppsDialog as Dialog };
